var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Switch",style:({
    'background-color': _vm.active
      ? _vm.$store.getters['theme/theme'].secondary
      : '#FFFFFF'
  })},[_c('div',{staticClass:"button",class:{ active: _vm.active },on:{"click":_vm.toggle}},[_c('div',{staticClass:"button-inner"})])])}
var staticRenderFns = []

export { render, staticRenderFns }